let data = {};
let mode = 2;
let Base = "";
switch (mode) {
  case 1:
    Base = "http://localhost";
    break;
  case 2:
    Base = "https://api.facturacion.sysge24.com";
    break;
  default:
    break;
}
switch (mode) {
  case 1: // dev local
    data = {
      BaseURI: `${Base}:8000/api/`,
      BasePublic: `${Base}:8000/`,
      BaseStorage: `${Base}:8000/storage/`,
      BaseStore: "http://localhost:3000/Sysge24/public/",
      Socket: `${Base}:11020`,
      mode: mode,
    };
    break;
  case 2: //NUEVO BOANA SYSGE-FACT
    data = {
      BaseURI: `${Base}/api/`,
      BasePublic: `${Base}/`,
      BaseStorage: `${Base}/storage/`,
      BaseStore: "http://154.12.229.44/php7/sysge24-fact/public/",
      //BaseStore: 'https://app.facturacion.sysge24.com/',
      Socket: `https://api.facturacion.sysge24.com/public:11021`,
      mode: mode,
    };
    break;
  default:
    break;
}
export default data;
